/**
 * Cart Discount Upsell
 * Handles add-to-cart for the upsell section in the cart drawer.
 */

(function () {
  'use strict';

  // Add-to-cart via event delegation — survives DOM re-renders
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-discount-upsell__add-btn');
    if (!btn) return;

    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data.sections) return;

        const parser = new DOMParser();

        if (data.sections['cart-drawer']) {
          const drawerInner = document.querySelector('cart-drawer .drawer__inner');
          if (drawerInner) {
            const newInner = parser
              .parseFromString(data.sections['cart-drawer'], 'text/html')
              .querySelector('.drawer__inner');
            if (newInner) drawerInner.innerHTML = newInner.innerHTML;
          }
        }

        if (data.sections['cart-icon-bubble']) {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            const newBubble = parser
              .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        }

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.classList.remove('is-empty');
      })
      .catch(function (err) {
        console.error('[cart-discount-upsell] Add to cart failed:', err);
        btn.removeAttribute('aria-busy');
      });
  });
})();
